module.exports = __webpack_public_path__ + "img/S1M6.cb963c29.jpg";